import { LockClosedOutline, MailOutline } from "@raresail/react-ionicons";
import { TAfterLogin } from "../../@types/common";
import { useAuth } from "../../components/context/AuthContext";
import { API_PROFILE_ME, API_TOKEN } from "../../constants/apis";
import { COMPONENT, REGISTER, TEXT } from "../../constants/constants";
import useAxios from "../common/useAxios";

export const useLoginForm = () => {
  const { login } = useAuth();
  const { get } = useAxios();

  const fields = [
    {
      label: "Email Address",
      field: "email",
      type: TEXT,
      required: true,
      props: {
        prefix: <MailOutline />,
      },
    },
    {
      field: "password",
      type: TEXT,
      required: true,
      props: {
        info: "Please enter your password",
        prefix: <LockClosedOutline />,
        type: "password",
      },
    },
    // {
    //   type: COMPONENT,
    //   component: <div className="textCenter font12">Forgot password</div>,
    // },
  ];

  const afterLogin = ({ data, onSuccess }: TAfterLogin) => {
    get({
      api: API_PROFILE_ME,
      token: data?.access,
      successHandler: onSuccess,
    });
  };

  const onSubmit = ({ payload }: any) => {
    return {
      api: API_TOKEN,
      params: payload,
      onSuccess: (data: any) => {
        if (data) login({ credentials: data, afterLogin });
      },
      successMessage: false,
    };
  };

  return { fields, onSubmit, route: REGISTER };
};
